var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        { attrs: { wrap: "", "align-center": "", "justify-center": "" } },
        [
          _c(
            "v-container",
            { attrs: { row: "", "justify-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { flex: "", xs12: "", sm12: "", md12: "", lg3: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", { staticClass: "pb-0 h6" }, [
                        _c("h2", [
                          _vm._v(_vm._s(_vm.$t("components.overview.details"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-title",
                        { staticClass: "text-body-2 py-1 font-weight-thin" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("components.overview.security"))
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        {
                          staticClass: "text-body-2",
                          attrs: { dense: "", "aria-label": "User Details" },
                        },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "components.overview.profile.username"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                { staticClass: "align-end text-wrap" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.username) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("components.overview.profile.email")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                { staticClass: "align-end text-wrap" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.email) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("components.overview.profile.points")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                { staticClass: "align-end text-wrap" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.zushinPoints) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "font-weight-thin",
                              attrs: {
                                "aria-label": "Download your data",
                                block: "",
                                small: "",
                                color: "accent",
                              },
                              on: { click: _vm.downloadUserData },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.overview.buttons.downloadData"
                                    )
                                  ) +
                                  "\n              "
                              ),
                              _c(
                                "v-icon",
                                { attrs: { small: "", right: "" } },
                                [
                                  _vm._v(
                                    "\n                fad fa-download\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showTotalDonations
                    ? _c(
                        "v-card",
                        [
                          _c("v-card-title", { staticClass: "pb-0" }, [
                            _c("h3", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("components.overview.donations.title")
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-card-title",
                            {
                              staticClass:
                                "text-body-2 pt-1 pb-0 font-weight-thin",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "components.overview.donations.subtitle"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "", "aria-label": "Donations" } },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c("v-list-item-content", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "components.overview.donations.remaining"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    { staticClass: "align-end" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.currentTotalDonations) +
                                          " / " +
                                          _vm._s(_vm.totalRequiredDonations) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-progress-linear", {
                                attrs: {
                                  "background-color": "primary",
                                  color: "success",
                                  role: "progressbar",
                                  value: _vm.donationsPercentage,
                                  "aria-valuemin": "0",
                                  "aria-valuemax": "100",
                                  "aria-valuenow": _vm.donationsPercentage,
                                  "aria-label": "Donation Progress",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "font-weight-thin mt-4",
                                  attrs: {
                                    block: "",
                                    small: "",
                                    color: "accent",
                                    to: _vm.toBuy,
                                    "aria-label": _vm.$t(
                                      "components.overview.buttons.buyZP"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.overview.buttons.buyZP"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", right: "" } },
                                    [
                                      _vm._v(
                                        "\n                fad fa-hands-heart\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "font-weight-thin mt-4",
                                  attrs: {
                                    "aria-label": "Donate",
                                    block: "",
                                    small: "",
                                    color: "accent",
                                    target: "_blank",
                                    href: _vm.toDonate,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.overview.buttons.donate"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", right: "" } },
                                    [
                                      _vm._v(
                                        "\n                fad fa-hands-heart\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    "offset-xs0": "",
                    xs12: "",
                    "offset-sm0": "",
                    sm12: "",
                    "offset-md0": "",
                    md12: "",
                    "offset-lg1": "",
                    lg8: "",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-app-bar",
                        { attrs: { flat: "", color: "primary" } },
                        [
                          _c("v-toolbar-title", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("components.overview.contact.title")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        {
                          staticClass:
                            "row xs12 sm12 md12 lg12 justify-center align-center",
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": "Facebook Page",
                                text: "",
                                color: "accent",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.viewReportCard(_vm.links.fbPage)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.overview.contact.buttons.fbPage"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": "Discord Invite",
                                text: "",
                                color: "accent",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.viewReportCard(_vm.links.discord)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.overview.contact.buttons.discord"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-app-bar",
                        { attrs: { flat: "", color: "primary" } },
                        [
                          _c("v-toolbar-title", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("components.overview.referral.title")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { attrs: { color: "secondary" } },
                        [
                          _vm.$vuetify.breakpoint.mdAndUp
                            ? _c(
                                "v-stepper",
                                { attrs: { "alt-labels": "" } },
                                [
                                  _c(
                                    "v-stepper-header",
                                    [
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            step: "1",
                                            "complete-icon": _vm.$t(
                                              "components.overview.referral.guide.0.icon"
                                            ),
                                            complete: "",
                                            color: "transparent",
                                            "aria-describedby": "step-desc-1",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g(
                                                            {
                                                              staticStyle: {},
                                                              domProps: {
                                                                textContent:
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "components.overview.referral.guide.0.title"
                                                                    )
                                                                  ),
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2866758635
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "components.overview.referral.guide.0.description"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            step: "2",
                                            "complete-icon": _vm.$t(
                                              "components.overview.referral.guide.1.icon"
                                            ),
                                            complete: "",
                                            color: "transparent",
                                            "aria-describedby": "step-desc-2",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g(
                                                            {
                                                              staticStyle: {},
                                                              domProps: {
                                                                textContent:
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "components.overview.referral.guide.1.title"
                                                                    )
                                                                  ),
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                448586602
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "components.overview.referral.guide.1.description"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            step: "3",
                                            "complete-icon": _vm.$t(
                                              "components.overview.referral.guide.2.icon"
                                            ),
                                            complete: "",
                                            color: "transparent",
                                            "aria-describedby": "step-desc-3",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g(
                                                            {
                                                              staticStyle: {},
                                                              domProps: {
                                                                textContent:
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "components.overview.referral.guide.2.title"
                                                                    )
                                                                  ),
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2929857897
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "components.overview.referral.guide.2.description"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            step: "4",
                                            "complete-icon": _vm.$t(
                                              "components.overview.referral.guide.3.icon"
                                            ),
                                            complete: "",
                                            color: "transparent",
                                            "aria-describedby": "step-desc-4",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g(
                                                            {
                                                              staticStyle: {},
                                                              domProps: {
                                                                textContent:
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "components.overview.referral.guide.3.title"
                                                                    )
                                                                  ),
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3956388584
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "components.overview.referral.guide.3.description"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            step: "5",
                                            "complete-icon": _vm.$t(
                                              "components.overview.referral.guide.4.icon"
                                            ),
                                            complete: "",
                                            color: "transparent",
                                            "aria-describedby": "step-desc-5",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g(
                                                            {
                                                              staticStyle: {},
                                                              domProps: {
                                                                textContent:
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "components.overview.referral.guide.4.title"
                                                                    )
                                                                  ),
                                                              },
                                                            },
                                                            on
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3082158575
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "components.overview.referral.guide.4.description"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$vuetify.breakpoint.smAndDown
                            ? _c(
                                "v-list",
                                { attrs: { "three-line": "" } },
                                _vm._l(
                                  _vm.referralGuides,
                                  function (currentStep, index) {
                                    return _c(
                                      "v-list-item",
                                      { key: "step-" + index },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          { attrs: { size: "25" } },
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(currentStep.icon)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  currentStep.title
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-flex",
                            { attrs: { lg12: "" } },
                            [
                              _c("v-alert", { attrs: { type: "info" } }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "components.overview.referral.guideLink"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-alert",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasCopied,
                                      expression: "hasCopied",
                                    },
                                  ],
                                  attrs: {
                                    type: "success",
                                    role: "status",
                                    "aria-live": "polite",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.overview.referral.copied"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "input-group--focused",
                                attrs: {
                                  "prepend-icon": "fad fa-share-all",
                                  "aria-label": "Referral Link",
                                  value: _vm.referralLink,
                                  "single-line": "",
                                  flat: "",
                                  readonly: "",
                                },
                                on: { focus: _vm.onReferralLink },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    "align-center": "",
                                    "text-center": "",
                                    "justify-center": "",
                                    lg12: "",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "fb-share-button",
                                      attrs: {
                                        "data-href": _vm.referralLink,
                                        "data-layout": "button",
                                        "data-size": "small",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "fb-xfbml-parse-ignore",
                                          attrs: {
                                            "aria-label":
                                              "Share Referral Link to FB",
                                            href:
                                              "https://www.facebook.com/sharer/sharer.php?u=" +
                                              _vm.referralLink +
                                              "&src=sdkpreparse",
                                            ripple: "",
                                            icon: "",
                                            text: "",
                                            color: "accent",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                small: "",
                                                "aria-hidden": "true",
                                              },
                                            },
                                            [_vm._v("fab fa-facebook")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "twitter-share-button",
                                      attrs: {
                                        "aria-label":
                                          "Share Referral Link to Twitter",
                                        href:
                                          "https://twitter.com/intent/tweet?url=" +
                                          _vm.referralLink,
                                        "data-size": "large",
                                        ripple: "",
                                        icon: "",
                                        text: "",
                                        color: "accent",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            "aria-hidden": "true",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    fab fa-twitter\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "v-subheader",
                            { attrs: { "text-center": "", inset: "" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.overview.referral.totalReferred"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-divider", { attrs: { inset: "" } }),
                          _vm._v(" "),
                          _c(
                            "v-progress-circular",
                            {
                              staticClass: "mt-3",
                              attrs: {
                                size: 100,
                                width: 15,
                                rotate: 90,
                                value: _vm.totalReferred,
                                color: "accent",
                                "aria-label": _vm.$t(
                                  "components.overview.referral.totalReferred"
                                ),
                                "aria-valuemin": "0",
                                "aria-valuemax": "100",
                                "aria-valuenow": _vm.totalReferred,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.totalReferred) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "v-subheader",
                            { attrs: { "text-center": "", inset: "" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.overview.referral.totalReferredCompleted"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-divider", { attrs: { inset: "" } }),
                          _vm._v(" "),
                          _c(
                            "v-progress-circular",
                            {
                              staticClass: "mt-3",
                              attrs: {
                                size: 100,
                                width: 15,
                                rotate: 90,
                                value: _vm.totalReferredCompleted,
                                color: "success",
                                "aria-label": _vm.$t(
                                  "components.overview.referral.totalReferredCompleted"
                                ),
                                "aria-valuemin": "0",
                                "aria-valuemax": "100",
                                "aria-valuenow": _vm.totalReferredCompleted,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.totalReferredCompleted) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }